export { default } from './stacked-slider';
